export default __webpack_public_path__ + "static/media/image1.d7119bb6.png";